import { ByTokenTypeCard } from '@app/feature/statistics/components/by-token-type/by-token-type.card';
import { useFilters } from '@app/feature/statistics/context/filters.context';
import { useCpmsBoGetTransactionReportsCountByTokenTypeQuery } from '@service/cpms-bo-transaction-reports-count-statistics.service';

export const ChargePointByTokenTypeCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetTransactionReportsCountByTokenTypeQuery({
    ...transformedFilters,
  });

  return <ByTokenTypeCard data={data} />;
};
